import * as Model from "@effect/sql/Model";
import { Schema } from "effect";

/**
 * Installation config event kind.
 *
 * Streamed from the management agent for every config-affecting action.
 *
 * @since 1.0.0
 */
export const InstallationConfigEventKind = Schema.Literal(
  "commit",
  "tag",
  "ratchet",
  "revert",
  "rollback",
  "doctor_alert",
  "clobbered_alert",
  "profile_published",
  "profile_rolled_back",
  "auth_failed",
);
export type InstallationConfigEventKind = Schema.Schema.Type<typeof InstallationConfigEventKind>;

/**
 * InstallationConfigLog model.
 *
 * Append-only event log of commits, ratchets, reverts and alerts that
 * affect an installation's config. Authoritative timeline for audit and
 * revert UX.
 *
 * @since 1.0.0
 */
export class InstallationConfigLog extends Model.Class<InstallationConfigLog>("InstallationConfigLog")({
  id: Model.Generated(Schema.String),
  installationId: Schema.String,
  sha: Schema.NullOr(Schema.String),
  eventKind: InstallationConfigEventKind,
  author: Schema.String,
  layer: Schema.NullOr(Schema.String),
  message: Schema.NullOr(Schema.String),
  filesChanged: Schema.NullOr(Schema.Unknown),
  trigger: Schema.NullOr(Schema.Unknown),
  createdAt: Model.DateTimeInsertFromDate,
}) {}
